// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".WordsContainer{margin-top:3rem;overflow:auto;position:absolute;bottom:0px;top:0px}.WordsContainerFixFormat{margin-top:5rem;overflow:auto;position:absolute;bottom:0px;top:0px;right:0;left:15px}.WordEdit{padding:8px;margin:5px;border-radius:0px;position:relative;border:none;border-bottom:1px solid var(--LineColor);min-height:2rem;font-size:.8rem;background-color:var(--SecondaryLight)}", ""]);
// Exports
module.exports = exports;
